import CustomInput from "@/components/shared/CustomInput";
import CustomSelect from "@/components/shared/CustomSelect";
import GENERAL, {
  SelectAllAreas,
  SelectAllCities,
  SelectEducationTypes,
  SelectLang,
  SelectSchoolTypes,
  SelectSchoolYears,
} from "@/redux/GENERAL";
import { useAppDispatch, useAppSelector } from "@/redux/store";
import React, { useEffect } from "react";

const index = ({ formikProps }: { formikProps: any }) => {
  const dispatch = useAppDispatch();
  const cities = useAppSelector(SelectAllCities);
  const areas = useAppSelector(SelectAllAreas);
  const languages = useAppSelector(SelectLang);
  const educationTypes = useAppSelector(SelectEducationTypes);
  const schoolYears = useAppSelector(SelectSchoolYears);
  const schoolTypes = useAppSelector(SelectSchoolTypes);
  //
  //
  //
  //
  //
  //

  useEffect(() => {
    dispatch(GENERAL.thunks.doGetALLCITIES({}));
    dispatch(GENERAL.thunks.doGetLanguages({}));
    dispatch(GENERAL.thunks.doGetSchoolYears({}));
    dispatch(GENERAL.thunks.doGetSchoolTypes({}));
  }, []);
  useEffect(() => {
    dispatch(GENERAL.thunks.doGetAllAreas({ cityid: formikProps.values.city }));
  }, [formikProps.values.city]);
  useEffect(() => {
    dispatch(
      GENERAL.thunks.doGetEducationTypes({
        school_year_id: formikProps.values.schoolYear,
      })
    );
  }, [formikProps.values.schoolYear]);

  return (
    <div>
      <div className=" grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3  gap-5 mb-5 items-center">
        <CustomInput
          type="text"
          name="schoolName"
          placeholder="اسم المدرسه"
          label="اسم المدرسه"
          FormikProps={formikProps}
          required={true}
        />
        <CustomSelect
          name="city"
          placeholder="المدينة"
          label="المدينة"
          data={cities}
          FormikProps={formikProps}
        />
        <CustomSelect
          name="country"
          placeholder="المنطقه"
          label="المنطقه"
          data={areas.map((item: any) => ({ id: item.id, name: item.name }))}
          FormikProps={formikProps}
        />
        <CustomSelect
          name="schoolYear"
          placeholder="الصف الدراسي"
          label="الصف الدراسي"
          data={schoolYears}
          FormikProps={formikProps}
        />
        {formikProps.values.schoolYear != "" &&
          formikProps.values.schoolYear !== 1 &&
          educationTypes &&
          educationTypes.length >= 1 && (
            <CustomSelect
              name="educationType"
              placeholder="الشعبه"
              label="الشعبه"
              data={educationTypes}
              FormikProps={formikProps}
            />
          )}
        <CustomSelect
          name="secondLanguage"
          placeholder="اللغة الثانية"
          label="اللغة الثانية"
          data={languages}
          FormikProps={formikProps}
        />
        <CustomSelect
          name="schoolType"
          placeholder="نوع المدرسة"
          label="نوع المدرسة"
          data={schoolTypes}
          FormikProps={formikProps}
        />
      </div>
    </div>
  );
};

export default index;
